/**
 * PAPI returns category names in title-case and sometimes singular
 * (e.g. "Flower", "Edible", "Concentrate"), while dispensary category
 * keys are lowercase and often plural (e.g. "flower", "edibles",
 * "concentrates"). Some states remap category names entirely
 * (e.g. PA uses "ingestibles" instead of "edibles").
 */

const STATE_CATEGORY_ALIASES: Record<string, string> = {
  ingestibles: 'edible',
};

export function categoryMatchesKey(papiCategory: string, categoryKey: string): boolean {
  if (!papiCategory || !categoryKey) {
    return false;
  }

  const normalized = papiCategory.toLowerCase();

  if (categoryKey === normalized) {
    return true;
  }

  if (categoryKey.startsWith(normalized)) {
    const suffix = categoryKey.slice(normalized.length);
    if (suffix === 's' || suffix === 'es') {
      return true;
    }
  }

  const alias = STATE_CATEGORY_ALIASES[categoryKey];
  return alias === normalized;
}
